import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { getDriverAccountToken } from 'shared/auth/AuthToken';

interface DriverAccountWrapperProps {
  children: ReactElement;
}

export function DriverAccountWrapper({ children }: DriverAccountWrapperProps) {
  const token = getDriverAccountToken();

  if (!token) {
    return <Navigate to="/driver-login" />;
  }

  return children;
}
